import {combineReducers} from 'redux'
import {get} from 'lodash'
import types from 'actions/types'

export const visibleSelling = (state = true, action) => {
  switch (action.type) {
    case types.SALES_TOGGLE_SUCCESS_STATS_SELLING:
      return action.showSuccessStats
    default:
      return state
  }
}

export const visibleLeads = (state = true, action) => {
  switch (action.type) {
    case types.SALES_TOGGLE_SUCCESS_STATS_LEADS:
      return action.showSuccessStats
    default:
      return state
  }
}

export const visibleWon = (state = true, action) => {
  switch (action.type) {
    case types.SALES_TOGGLE_SUCCESS_STATS_WON:
      return action.showSuccessStats
    default:
      return state
  }
}

export const stats = (state = null, action) => {
  switch (action.type) {
    case types.SALES_LOAD_SUCCESS_STATS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const loading = (state = false, action) => {
  switch (action.type) {
    case types.SALES_LOAD_SUCCESS_STATS_ATTEMPT:
      return true
    case types.SALES_LOAD_SUCCESS_STATS_SUCCESS:
      return false
    case types.SALES_LOAD_SUCCESS_STATS_FAILURE:
      return false
    case types.SALES_UPDATE_USER_OR_TEAM:
      return true
    case types.SALES_UPDATE_SUCCESS_STATS_FILTERS:
      return true
    default:
      return state
  }
}

export const stageModifiedStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SUCCESS_STATS_FILTERS:
      return get(action, 'filters.stageModifiedStart', state)
    default:
      return state
  }
}

export const stageModifiedEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SUCCESS_STATS_FILTERS:
      return get(action, 'filters.stageModifiedEnd', state)
    default:
      return state
  }
}

export const stageModifiedTimeKey = (state = 'fyear:0', action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SUCCESS_STATS_FILTERS:
      return get(action, 'filters.stageModifiedTimeKey', state)
    default:
      return state
  }
}

export default combineReducers({
  visibleSelling,
  visibleLeads,
  visibleWon,
  stats,
  loading,
  stageModifiedStart,
  stageModifiedEnd,
  stageModifiedTimeKey,
})
